export default __webpack_public_path__ + "static/15-ec6a49c1e84c5b8abbd824fc4708c908.png";